// CropRecommendation.js
// CropRecommendation.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; // coming from the react libraries
import axios from 'axios'; // that is library coming from the data which is coming from mongoDB
import './CropRecommendation.css';

const CropRecommendation = () => {
  const [recommendation, setRecommendation] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();


  // each farmer's data is once reflected once the middle ware connection will eshtablished
  useEffect(() => {
    const fetchRecommendation = async () => {
      try {
        const res = await axios.get(`https://krimaanapp-4.onrender.com/api/recommendation/${id}`);
        setRecommendation(res.data);
      } catch (err) {
        console.error('Error fetching recommendation data', err);
      }
    };
    fetchRecommendation();
  }, [id]);

  const handleBack = () => {
    navigate(`/farmer/${id}`);
  };

  const handleLogout = () => {
    navigate('/login');
  };

  return (
    <div data-aos='fade-up' data-aos-duration='1000' className="crop-recommendation-page">
      <div className ='logout_and_back'>
        <div className='back_button_div'>
      <button className="back-button" onClick={handleBack}>Back to Farmer Information</button>
        </div>
        <div className='logout_button_div'>
      <button className="logout-button" onClick={handleLogout}>Logout</button>
        </div>
      </div>
      <h2>Crop Recommendation for Farmer ID: {id}</h2>
      {/* <p>{recommendation.details || 'No recommendation available'}</p> */}

      <div className='crop_recommendation_div'>
   <div className='each_div'>
        <h1>January-March</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Tomato</p>
        <p>Potato</p>
        <p>Turmeric</p>
        <p>Beans</p>
        <p>Cauliflower</p>
        <p>Carrots</p>
        <p>Chilli</p>
        <p>Shimla Chilli</p>
      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Apricot</p>
        <p>Pear</p>
        <p>Kiwi</p>
        <p>Apples</p>
        <p>Plum</p>
        <p>Peach</p>
        <p>Guava</p>
      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Green Peas</p>
      </div>
    </div>
   </div>


   <div className='each_div'>
        <h1>April-May</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Harvesting Time</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Growing</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Harvesting time</p>
      </div>
    </div>
   </div>





   <div className='each_div'>
        <h1>June-July</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Growing</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Harvesting</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Maize</p>
      </div>
    </div>
   </div>



   <div className='each_div'>
        <h1>July-August</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Growing</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p> Pear Harvesting</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Rajma</p>
        <p>Mu</p>
        <p>Urat</p>
      </div>
    </div>
   </div>


   <div className='each_div'>
        <h1>September</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Harvesting</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Harvesting</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Harvesting</p>

      </div>
    </div>
   </div>



   <div className='each_div'>
        <h1>October</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Garlic</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Harvesting</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Black Gram</p>
        <p>Wheat</p>
        <p>Red Gram</p>
        <p>Green Gram</p>

      </div>
    </div>
   </div>





   <div className='each_div'>
        <h1>November-December</h1>
    <div className ='div_details'>
      <div className='first_div'>
        <h3>Vegetables</h3>
        <p>Harvesting Season , Rest is Growing</p>

      </div>
      <div className='second_div'>
        <h3>Fruits</h3>
        <p>Harvesting</p>

      </div>
      <div className='third_div'>
        <h3>Pulses</h3>
        <p>Harvesting Season</p>
      </div>
    </div>
   </div>




      </div>

    </div>
  );
};

export default CropRecommendation;

